module.exports = __webpack_public_path__ + "static/media/知著1420-彩钢公寓.0d40d5fe.pdf";